<script setup>
// Release notes of the newer build, shown inside the update dialog and the update notice.
// Notes come from the PRs' "Release notes" sections (untrusted), so they are rendered as plain
// text only. On dev (notesMode 'pr') the PRs in the build are also listed with links.
defineProps({
  notes: { type: String, default: '' },
  notesMode: { type: String, default: 'release' },
  prs: { type: Array, default: () => [] },
});
</script>

<template>
  <div
    v-if="notes || prs.length"
    class="version-notes"
  >
    <p class="version-notes-heading">
      {{ $t("What's new") }}
    </p>
    <div
      v-if="notes"
      class="version-notes-body"
    >
      {{ notes }}
    </div>
    <ul
      v-if="notesMode === 'pr' && prs.length"
      class="version-notes-prs"
    >
      <li
        v-for="pr in prs"
        :key="pr.number"
      >
        <a
          :href="pr.url"
          target="_blank"
          rel="noopener"
        >#{{ pr.number }} {{ pr.title }}</a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.version-notes {
  width: 100%;
  text-align: left;
}

.version-notes-heading {
  margin: 0 0 6px 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--wp-text-primary);
}

.version-notes-prs {
  margin: 0 0 8px 0;
  padding-left: 18px;
  font-size: 0.8125rem;
}

.version-notes-prs a {
  color: var(--wp-text-link);
}

.version-notes-prs a:hover {
  color: var(--wp-text-link-hover);
}

.version-notes-body {
  max-height: 200px;
  overflow-y: auto;
  padding: 8px 10px;
  border: 1px solid var(--wp-border-primary);
  border-radius: 8px;
  background: var(--wp-surface-secondary);
  color: var(--wp-text-primary);
  font-size: 0.8125rem;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
